import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Run translation validation in development mode
if (import.meta.env.DEV) {
  import('./utils/translationValidator').then(({ logTranslationValidation }) => {
    // Delay to ensure console is ready
    setTimeout(logTranslationValidation, 1500);
  });
}

createRoot(document.getElementById("root")!).render(<App />);

// Defer service worker registration until page is interactive
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Wait for idle time to register SW
    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(() => {
        navigator.serviceWorker.register('/sw-push.js');
      });
    } else {
      setTimeout(() => {
        navigator.serviceWorker.register('/sw-push.js');
      }, 1000);
    }
  });
}
